var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsTransplantOn = function SvgPartsTransplantOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5D5",
    d: "M11.54 19.395c-2.992-1.386-5.103-4.107-5.65-7.51l-.514-3.21s4.64-.727 4.64 4.467c0 5.193 1.524 6.253 1.524 6.253M20.463 19.395c2.993-1.386 5.104-4.107 5.65-7.51l.515-3.21s-4.64-.727-4.64 4.467c0 5.193-1.525 6.253-1.525 6.253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "m26.252 8.615-.515 3.209c-.763 4.754-4.857 8.204-9.735 8.204s-8.972-3.45-9.735-8.204L5.87 9.133c-.034-.207-.148-.034-.355 0-.208.033-.521-.208-.487 0l.487 2.812a10.43 10.43 0 0 0 4.659 7.13v4.686a.38.38 0 1 0 .761 0v-4.238a10.7 10.7 0 0 0 5.067 1.267c1.832 0 3.556-.46 5.067-1.267v4.238a.381.381 0 0 0 .762 0v-4.687a10.43 10.43 0 0 0 4.658-7.129l.515-3.209a.38.38 0 1 0-.752-.121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M14.126 9.077c.526.49 1.2.736 1.876.736s1.35-.246 1.876-.736l.599-.56a.381.381 0 0 0-.52-.557l-.6.56c-.76.709-1.95.709-2.71 0l-.6-.56a.381.381 0 0 0-.52.557zM12.053 13.28c1.125.591 2.537.888 3.95.888 1.41 0 2.822-.297 3.948-.889a.381.381 0 0 0-.355-.674c-2.015 1.06-5.172 1.06-7.188 0a.38.38 0 1 0-.355.674M6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143M5.133 8.7 2.868 6.435l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsTransplantOn;